/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Room_CountInputs */

const cs_form_room_count = /** @type {(inputs: Form_Room_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počet pokojů (inzerát)`)
};

const en_form_room_count = /** @type {(inputs: Form_Room_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Room count (advert)`)
};

/**
* | output |
* | --- |
* | "Room count (advert)" |
*
* @param {Form_Room_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_room_count = /** @type {((inputs?: Form_Room_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Room_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_room_count(inputs)
	return cs_form_room_count(inputs)
});